/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignFromJSON, ApiCampaignToJSON, } from './ApiCampaign';
import { ApiComponentFromJSON, ApiComponentToJSON, } from './ApiComponent';
import { ApiInsertionTypeFromJSON, ApiInsertionTypeToJSON, } from './ApiInsertionType';
import { ApiLocationFromJSON, ApiLocationToJSON, } from './ApiLocation';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiPersonalisationFromJSON(json) {
    return ApiPersonalisationFromJSONTyped(json, false);
}
export function ApiPersonalisationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appliedTo': !exists(json, 'appliedTo') ? undefined : json['appliedTo'],
        'campaign': !exists(json, 'campaign') ? undefined : ApiCampaignFromJSON(json['campaign']),
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'component': !exists(json, 'component') ? undefined : ApiComponentFromJSON(json['component']),
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'insertionType': !exists(json, 'insertionType') ? undefined : ApiInsertionTypeFromJSON(json['insertionType']),
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiUserFromJSON(json['lastUser']),
        'lastUserId': !exists(json, 'lastUserId') ? undefined : json['lastUserId'],
        'location': !exists(json, 'location') ? undefined : ApiLocationFromJSON(json['location']),
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : ApiUserFromJSON(json['owner']),
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'pending': !exists(json, 'pending') ? undefined : (new Date(json['pending'])),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}
export function ApiPersonalisationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appliedTo': value.appliedTo,
        'campaign': ApiCampaignToJSON(value.campaign),
        'campaignId': value.campaignId,
        'component': ApiComponentToJSON(value.component),
        'componentId': value.componentId,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'description': value.description,
        'id': value.id,
        'insertionType': ApiInsertionTypeToJSON(value.insertionType),
        'lastUser': ApiUserToJSON(value.lastUser),
        'lastUserId': value.lastUserId,
        'location': ApiLocationToJSON(value.location),
        'locationId': value.locationId,
        'name': value.name,
        'owner': ApiUserToJSON(value.owner),
        'ownerId': value.ownerId,
        'pending': value.pending === undefined ? undefined : (value.pending.toISOString()),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
    };
}
